import { useEffect, useState } from "react"

export type OneTimeAnimationStore = {
  hasPlayed: boolean
}

export function createOneTimeAnimationStore(): OneTimeAnimationStore {
  return { hasPlayed: false }
}

export function useOneTimeAnimation(store: OneTimeAnimationStore) {
  const [shouldAnimate] = useState(() => !store.hasPlayed)

  useEffect(() => {
    if (shouldAnimate) {
      store.hasPlayed = true
    }
  }, [shouldAnimate, store])

  return shouldAnimate
}
